import { dateTime, defineAction, enumerated, object, string } from '~/prix'
import agentAvailabilityStopAction from './agentAvailabilityStop.action.json'

const agentAvailabilityStopDefinition = defineAction({
  ...agentAvailabilityStopAction,
  userActivityLog: true,
  input: object({
    agentCpf: string(),
  }),
  output: object({
    status: enumerated({
      unavailable: 'unavailable',
    }),
    changedAt: dateTime(),
  }),
})

export default agentAvailabilityStopDefinition
